// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2VkrR","header":"MessagesList_header__WDJcK","chat":"MessagesList_chat__d3JaG"};